import * as React from 'react';

const RotateRight16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M13.146 2.854a.5.5 0 0 1 .854.353V6a.5.5 0 0 1-.5.5h-2.793a.5.5 0 0 1-.353-.854l.823-.823A4.48 4.48 0 0 0 8 3.5 4.505 4.505 0 0 0 3.5 8 4.5 4.5 0 0 0 8 12.5a4.48 4.48 0 0 0 4.005-2.488c.15-.298.442-.512.776-.512.518 0 .896.491.683.962A6 6 0 0 1 8 14a6 6 0 0 1-4.924-2.571A5.96 5.96 0 0 1 2 8c0-3.309 2.691-6 6-6a5.97 5.97 0 0 1 4.235 1.765z"
  }
));
RotateRight16.Size = 16;
RotateRight16.Title = "RotateRight";

export { RotateRight16 as default };
